const listeners = new Set<(key: string, snapshot: string) => void>();
export function draftConfirmed(key: string, snapshot: string) { listeners.forEach(fn => fn(key, snapshot)); }
export function watchDraftConfirmation(fn: (key: string, snapshot: string) => void) {
  listeners.add(fn); return () => { listeners.delete(fn); };
}
